import { render, staticRenderFns } from "./IndexSales.vue?vue&type=template&id=0e51a07c&scoped=true&"
import script from "./IndexSales.vue?vue&type=script&lang=js&"
export * from "./IndexSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51a07c",
  null
  
)

export default component.exports